export const APP_PLATFORM = process.env.APP_PLATFORM || 'workstation';
export const APP_NAME = `NZOS-CTV-${APP_PLATFORM}`; // Use a descriptive service name
export const APP_VERSION = process.env.npm_package_version || '0.0.1'; // Fallback to a default version if not set

export const PUBLIC_PATH = process.env.PUBLIC_PATH || '/';

export const OTEL_ENABLED = Boolean(process.env.OTEL_EXPORTER_OTLP_ENABLED) || false; // Default to false if not set
// export const FIREBASE_ENABLED = Boolean(process.env.FIREBASE_ENABLED) || false; // Default to false if not set
